import Modal from "@commons/Modal";
import { usePage } from "@hooks/usePage";
import { toast } from "react-toastify";
import Text from "@commons/Typography/Text";
import { useGetVisitById } from "@services/visits/getById";
import { useEffect } from "react";
import { prepareVisitDetail } from "@utils/translator/visits";
import Heading from "@commons/Typography/Heading";
import AttachmentPreview from "@commons/Preview/AttachmentPreview";
import { usePermissions } from "@hooks/usePermissions";

function DetailsModalVisit({ visitId }: { visitId: string }) {
  const { isModalOpen, closeModal, openModal, setDataModal } = usePage();
  const open = isModalOpen("detailsVisit");
  const { can } = usePermissions();

  const { error, isLoading, data } = useGetVisitById(visitId);

  useEffect(() => {
    if (error) {
      toast.error("Erro ao carregar os dados da visita.");
      closeModal();
    }
  }, [error, closeModal]);

  if (!open || !data?.visit) return null;

  const handleEdit = () => {
    console.log(visit);
    setDataModal({ id: visit.id });
    openModal("editVisit");
  };

  const visit = prepareVisitDetail(data.visit);
  const attachments = data.attachmentsWithUrls;

  const formAttachments = attachments.filter((a) => a.fileType === "form");
  const photoReportAttachments = attachments.filter(
    (a) => a.fileType === "photo_report",
  );

  const handleClose = () => {
    closeModal();
  };

  const canUpdateVisit = can("update", "visits");

  return (
    <Modal
      open={open}
      heading="Detalhes da Visita"
      onClose={handleClose}
      onEdit={canUpdateVisit ? handleEdit : undefined}
      confirmLabel="Salvar"
      cancelLabel="Cancelar"
      className="max-w-2xl relative"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
        <section className="flex flex-col gap-4">
          <div className="flex flex-col">
            <Heading size="sm">Data da Visita:</Heading>
            <Text className="font-roboto">{visit.date}</Text>
          </div>

          <div className="flex flex-col">
            <Heading size="sm">Local Visitado:</Heading>
            <Text className="font-roboto">Código: {visit.location.code}</Text>
          </div>

          <div className="flex flex-col">
            <Heading size="sm">Equipe Responsável:</Heading>
            <Text className="font-roboto">{visit.responsibleTeam}</Text>
          </div>
        </section>

        <section className="flex flex-col">
          <Heading size="sm">Amostras Biológicas Coletadas:</Heading>
          <div className="font-roboto flex flex-col">
            {visit.sampleTypes?.map((sample, i) => (
              <Text key={i}>{sample}</Text>
            ))}
          </div>
        </section>

        <section className="md:col-span-2">
          <Heading size="sm" className="mb-1">
            Formulários:
          </Heading>
          {!isLoading && !error && formAttachments?.length > 0 ? (
            <AttachmentPreview attachments={formAttachments} />
          ) : (
            <Text className="text-gray-500 text-sm">
              Sem anexos de formulário
            </Text>
          )}
        </section>

        <section className="md:col-span-2">
          <Heading size="sm" className="mb-1">
            Fotos:
          </Heading>
          {!isLoading && !error && photoReportAttachments?.length > 0 ? (
            <AttachmentPreview attachments={photoReportAttachments} />
          ) : (
            <Text className="text-gray-500 text-sm">
              Sem anexos de relatório fotográfico
            </Text>
          )}
        </section>
      </div>
    </Modal>
  );
}

export default DetailsModalVisit;
